export const WERTE = [
  "Akzeptanz", "Achtsamkeit", "Nachhaltigkeit", "Selbstständigkeit",
  "Spiritualität", "Klarheit", "Gesundheit", "Stabilität",
  "Natur", "Entwicklung", "Verantwortung", "Neugierde",
  "Balance", "Hilfsbereitschaft", "Hoffnung", "Sicherheit",
  "Abenteuer", "Dankbarkeit", "Humor", "Zuneigung",
  "Ruhm", "Fröhlichkeit", "Intuition", "Effizienz",
  "Optimismus", "Vertrauen", "Gleichheit", "Ordnung",
  "Macht", "Toleranz", "Kreativität", "Verlässlichkeit",
  "Engagement", "Treue", "Wissen", "Beliebtheit",
  "Großzügigkeit", "Einfachheit", "Qualität", "Erfolg",
  "Flexibilität", "Objektivität", "Liebe", "Leidenschaft",
  "Gerechtigkeit", "Transparenz", "Autonomie", "Loyalität",
  "Realismus", "Integrität", "Freiheit", "Familie",
  "Wohlstand", "Offenheit", "Nähe", "Authentizität",
  "Kooperation", "Herausforderung", "Leistung", "Schönheit",
  "Ehrlichkeit", "Harmonie", "Mut", "Respekt",
];

export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
